<template>
  <div>
    <base-select
      :title="title"
      :placeholder="placeholder"
      :search_able="true"
      :search_in_front="false"
      :float-title="true"
      :loading="loadingGetCodes"
      v-model="code_id"
      :options="options"
      :errorMessage="errorMessage"
      :disabled-options="disabledOptions"
      :can-load-more="hasNextPageCodes"
      @loadMore="loadMoreCodes"
      :icon="icon"
    />
  </div>
</template>

<script setup>
import BaseSelect from '@/components/base/select/BaseSelect.vue'
import { watch, onMounted, ref, defineProps, defineEmits, computed } from 'vue'
import { apiGetCodes } from '@/services/users/Users'

const uuid = Math.random().toString(36).slice(2)
const loadingGetCodes = ref(false)
const code_id = ref(null)
const codes = ref([])
const hasNextPageCodes = ref(false)
const pageCodes = ref(1)

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: null,
  },
  icon: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: null,
  },
  errorMessage: {
    type: String,
    default: null,
  },
  additionalOptions: {
    type: Array,
    default: () => [],
  },
  disabledOptions: {
    type: Array,
    default: [],
  },
})

onMounted(() => {
  getCodes(props.modelValue ?? undefined)
})

const options = computed(() => {
  return [...props.additionalOptions, ...codes.value]
})

async function getCodes(search = '') {
  loadingGetCodes.value = true
  try {
    const response = await apiGetCodes(uuid, {
      search: search,
      paginate: 10,
      page: pageCodes.value,
    })

    if (!response) return
    if (pageCodes.value === 1) {
      codes.value = response?.data?.codes?.data
    } else {
      codes.value = [...codes.value, ...response?.data?.codes?.data]
    }
    if (props.modelValue) code_id.value = props.modelValue
    hasNextPageCodes.value = pageCodes.value < response?.data?.codes?.last_page
  } catch (error) {
    console.log(error)
  } finally {
    loadingGetCodes.value = false
  }
}

function loadMoreCodes(arg) {
  if (arg?.page) {
    pageCodes.value = arg.page
  } else {
    pageCodes.value++
  }

  if (pageCodes.value === 1) {
    codes.value = []
  }
  getCodes(arg?.search || '')
}

watch(
  () => code_id.value,
  (newValue) => {
    emit('update:modelValue', newValue)
  },
)
</script>

<style scoped></style>
